// The title bar's height is not fixed: it is one row on pages without a breadcrumb trail
// and two rows (global tier + context lane) on pages with one. The page layouts below it
// were all sized for the old fixed 55px bar, as `calc(100vh - Npx)` where N includes 55.
//
// HomePage publishes the bar's measured height on its container as two CSS variables:
//   --title-bar-height  the bar's real height
//   --title-bar-offset  how far it differs from the 55px those layouts assumed
// A layout under the bar subtracts the offset from 100vh:
//   calc(100vh - var(--title-bar-offset, 0px) - Npx)
// A full-screen overlay that covers the bar resets the offset to 0 (`resetTitleBarOffset`),
// so layouts inside it keep their own math. Outside HomePage both variables fall back to
// the legacy values, which leaves every layout exactly as it was sized.
export const LEGACY_TITLE_BAR_HEIGHT = 55;

export const TITLE_BAR_HEIGHT = `var(--title-bar-height, ${LEGACY_TITLE_BAR_HEIGHT}px)`;
export const TITLE_BAR_OFFSET = 'var(--title-bar-offset, 0px)';

export const titleBarVariables = height => (
  height
    ? `--title-bar-height: ${height}px; --title-bar-offset: ${height - LEGACY_TITLE_BAR_HEIGHT}px;`
    : ''
);

export const resetTitleBarOffset = '--title-bar-offset: 0px;';
